import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="bg-white px-4 py-20" data-id="element-113">
      <div className="mx-auto max-w-3xl text-center" data-id="element-114">
        <h2 className="mb-12 text-3xl font-black text-brand-text md:text-4xl" data-id="element-115">
          🏆 Spezielles Launch-Angebot
        </h2>

        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-green bg-white p-8 pt-11 shadow-xl md:p-12 md:pt-14" data-id="element-116">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-green px-6 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-117">
            Kit-Inhalt:
          </div>

          <div className="mb-8 space-y-4 text-left" data-id="element-118">
            <div className="flex items-center justify-between gap-4 border-b border-brand-creamDark pb-4" data-id="element-119">
              <span className="font-medium text-brand-text" data-id="element-120">
                5 komplette digitale Bände
              </span>
              <span className="font-medium text-brand-terracotta" data-id="element-121">47 €</span>
            </div>
            <div className="flex items-center justify-between gap-4 border-b border-brand-creamDark pb-4" data-id="element-122">
              <span className="font-medium text-brand-text" data-id="element-123">
                5 exklusive Boni
              </span>
              <span className="font-medium text-brand-terracotta" data-id="element-124">95 €</span>
            </div>
            <div className="flex items-center justify-between gap-4 pt-2" data-id="element-125">
              <span className="font-bold text-brand-text" data-id="element-126">GESAMTWERT:</span>
              <span className="font-bold text-brand-terracotta line-through" data-id="element-127">
                142 €
              </span>
            </div>
          </div>

          <div className="mb-8 text-center" data-id="element-128">
            <div className="mb-2 flex items-center justify-center gap-3" data-id="element-129">
              <span className="text-4xl" aria-hidden="true" data-id="element-130">
                🏆
              </span>
              <span className="text-6xl font-black tracking-tight text-brand-green md:text-7xl" data-id="element-131">
                19 €
              </span>
            </div>
            <span className="text-lg font-medium text-brand-gray line-through" data-id="element-132">
              142 €
            </span>
          </div>

          <CTAButton href="https://yoga-bereit.impultienda.ar/checkout" className="mb-6 w-full py-5 text-base md:text-lg" data-id="element-133">
            ICH WILL DAS YOGA BEREIT KIT
          </CTAButton>

          <p className="text-xs font-medium leading-relaxed text-brand-gray" data-id="element-134">
            Sofortiger Download &middot; Einmalzahlung &middot; Lebenslanger
            Zugang &middot; 7 Tage Garantie
          </p>
        </div>
      </div>
    </section>;
}